import styles from "./MobileFilterBar.module.css"
import { countActiveFilters } from "./filterConstants.js"
import type { Filters } from "./useBenefits.js"

interface Props {
  filters: Filters
  onOpenDrawer: () => void
}

export function MobileFilterBar({ filters, onOpenDrawer }: Props) {
  const activeCount = countActiveFilters(filters)

  return (
    <div className={styles.bar}>
      <button type="button" className={styles.detailButton} onClick={onOpenDrawer}>
        絞り込み
        {activeCount > 0 && <span className={styles.badge}>{activeCount}</span>}
      </button>
    </div>
  )
}
